module.exports = __webpack_public_path__ + "media/images/breadcrumb-home-5d924f150ede9bb25842d39242e8cc4b.png";